// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"804":"f8b3f279","863":"317bb0f2"}[chunkId] + ".chunk.css";
};